import { useMemberMutations } from "@app/entities/member/mutations";
import { T_MemberAvailability } from "@app/entities/member/types";
import { useMember } from "@app/providers/MemberContextProvider";
import Form from "antd/lib/form";
import notification from "antd/lib/notification";
import { useRef } from "react";

const DEBOUNCE_TIME = 500;

export const useMemberAvailabilityFormLoader = () => {
  const { isMembersPending } = useMember();
  const { updateMemberAvailability, isMutationPending } = useMemberMutations();

  // Use ref to set a timer for debouncing
  const timeoutRef = useRef<NodeJS.Timeout | number | null>(null);
  const [memberAvailabilityForm] = Form.useForm();

  const debouncedUpdateAvailability = async ({
    key,
    value,
  }: {
    key: keyof T_MemberAvailability;
    value: string | boolean;
  }) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(async () => {
      if (key === "rangeInMiles" && Number(value) > 25) {
        return notification.error({
          description: "Range in miles cannot exceed 25.",
          message: "Error",
        });
      }
      if (key === "elevationMaximum" && Number(value) > 50) {
        return notification.error({
          description: "Elevation maximum cannot exceed 50.",
          message: "Error",
        });
      }
      updateMemberAvailability(
        { [key]: value },
        {
          onSuccess: () => memberAvailabilityForm.resetFields(),
        }
      );
    }, DEBOUNCE_TIME);
  };

  const isLoading = isMutationPending || isMembersPending;
  return {
    isLoading,
    memberAvailabilityForm,
    debouncedUpdateAvailability,
    updateMemberAvailability,
  };
};
